import { css } from 'lit';

export default css`
    vaadin-select {
        background-color: var(--tcg-input-container-background-color);
        border-radius: var(--tcg-input-container-border-radius);
        border-bottom: -8px; /* fix the margin-bottom of the inner element */
    }

    vaadin-select[transparent] {
        background-color: transparent;
    }

    vaadin-context-menu-item.warning {
        color: firebrick;
    }


    sdb-nav-mainmenu-item,
    sdb-nav-mainmenu-item::part(menu-item),
    sdb-content-icon.dashboardTileIcon {
        --text-light: var(--tcg-primary-color-onsecondary);
    }

    sdb-content-button:not([secondary]) {
        --text-light: var(--sdb-button-primary-text);
    }

    md-fab {
        --md-fab-icon-color: var(--tcg-primary-color-onsecondary);
        --md-fab-container-color: var(--btn-primary, var(--accent-color));
        position: fixed;
        bottom: 16px;
        right: 16px;
    }

    @media (max-width: 640px) {
        :host {
            --tcg-list-padding: 0;
        }
    }

    sdb-content-collapsablecard {
        --sdb-content-collapsablecard-background: #fff;
    }

    sdb-content-accordion {
        --sdb-content-accordionitem-background-color: white;
        --sdb-content-accordionheading-background: white;
        --sdb-content-collapsablecard-background: white;
    }
`;
